import { useSmartMutation, useSmartQuery } from "@shared/api/queries/hooks";
import { QueryKeyFactory } from "@shared/api/queries/queryKeyFactory";
import { useRemoteUtilityId } from "@shared/selectors/globalSelectors";
import { axSystemAlertsApi } from "./api";
import { SystemAlertRecommendationFilters } from "./types";
import { useMemo } from "react";
import { useQueryClient } from "@tanstack/react-query";
import { useToast } from "@shared/hooks/use-toast";
import { queryClient } from "@shared/api/queries/queryClient";

export const useRecommendationsDashboardKpis = () => {
  const remoteUtilityId = useRemoteUtilityId();

  return useSmartQuery(
    QueryKeyFactory.module.ax.serviceAndMangement.systemAlert.dashboardKpis(
      remoteUtilityId
    ),
    () => axSystemAlertsApi.getRecommendationsDashboardKpis(remoteUtilityId),
    {
      enabled: !!remoteUtilityId,
    }
  );
};
export const useSystemAlertRecommendations = (
  filters: SystemAlertRecommendationFilters = {}
) => {
  const remoteUtilityId = useRemoteUtilityId();

  return useSmartQuery(
    QueryKeyFactory.module.ax.serviceAndMangement.systemAlert.recommendations(
      remoteUtilityId,
      filters
    ),
    () => axSystemAlertsApi.getRecommendations(remoteUtilityId, filters),
    {
      enabled: !!remoteUtilityId,
    }
  );
};
// In your hooks file, add these mutation hooks following your structure:

export const useDismissAlert = () => {
  const { toast } = useToast();
  const remoteUtilityId = useRemoteUtilityId();

  return useSmartMutation(
    (alertId: number): Promise<any> => {
      return axSystemAlertsApi.dismissAlert(alertId);
    },
    {
      onSuccess: (data) => {
        toast({
          title: "Success!",
          description: `${data.message}`,
        });

        queryClient.invalidateQueries({
          queryKey:
            QueryKeyFactory.module.ax.serviceAndMangement.systemAlert.recommendations(
              remoteUtilityId,
              {}
            ),
        });

        queryClient.invalidateQueries({
          queryKey:
            QueryKeyFactory.module.ax.serviceAndMangement.systemAlert.dashboardKpis(
              remoteUtilityId
            ),
        });
      },

      onError: (error: any) => {
        toast({
          title: "Error",
          description: error?.message || "Failed to dismiss alert",
          variant: "destructive",
        });
      },
    }
  );
};

export const useReviewAlert = () => {
  const { toast } = useToast();
  const remoteUtilityId = useRemoteUtilityId();

  return useSmartMutation(
    (alertId: number): Promise<any> => {
      return axSystemAlertsApi.reviewAlert(alertId);
    },
    {
      onSuccess: (data) => {
        toast({
          title: "Success!",
          description: `${data.message}`,
        });

        queryClient.invalidateQueries({
          queryKey:
            QueryKeyFactory.module.ax.serviceAndMangement.systemAlert.recommendations(
              remoteUtilityId,
              {}
            ),
        });

        queryClient.invalidateQueries({
          queryKey:
            QueryKeyFactory.module.ax.serviceAndMangement.systemAlert.dashboardKpis(
              remoteUtilityId
            ),
        });
      },

      onError: (error: any) => {
        toast({
          title: "Error",
          description: error?.message || "Failed to review alert",
          variant: "destructive",
        });
      },
    }
  );
};
